import React, { Component } from 'react';
import {
  Paper,
  Grid,
  Typography,
  Tabs,
  Tab,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem
} from '@material-ui/core';

import moment from 'moment'

import LocationSelect from '../LocationSelect';
import DateRangePicker from '../DateRangePicker';
import SpendingOverviewTable from './SpendingOverviewTable'

const typeValues = ['CostCentre', 'Supplier'];

class SpendingOverview extends Component {

  constructor(props) {
    super();
    this.state = {
      spending: [],
      status: 'pending',
      type: 'Supplier',
      location: null,
      startDate: null,
      endDate: null
    }
    this.handleUpdate = this.handleUpdate.bind(this)
    this.setDateRange = this.setDateRange.bind(this)
    this.setType = this.setType.bind(this)
  }

  handleUpdate(payload) {
    let [field, value] = Object.entries(payload)[0]
    if (field === 'location') {
      value = value || {}
      value = value.name;
    }
    this.setState({
      [field]: value
    })
  }

  setDateRange(range) {
    let { startDate, endDate } = range;
    if (startDate && endDate) {
      startDate = moment(startDate).format("YYYY-MM-DD")
      endDate = moment(endDate).format("YYYY-MM-DD")
    }
    this.setState({ startDate, endDate })
  }

  setType(event, value) {
    this.setState({
      type: typeValues[value]
    })
  }

  render() {

    const { status, startDate, endDate, location, type } = this.state;
    const tabValue = typeValues.indexOf(type);

    return (
      <Grid item xs={12} md={12}>
        <Typography style={{marginBottom: '32px'}} variant="h5">
          Spending overview
        </Typography>
        <Paper style={{marginBottom: '16px'}}>
          <Tabs value={tabValue} onChange={this.setType} indicatorColor="primary" textColor="primary">
            <Tab label="By cost centre" />
            <Tab label="By supplier" />
          </Tabs>
        </Paper>
        <Paper style={{padding: '10px 10px', marginBottom: '16px'}}>
          <Grid container spacing={2}>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
                <InputLabel>Purchase order status</InputLabel>
                <Select
                  onChange={(event) => this.handleUpdate({status: event.target.value})}
                  value={status}
                >
                  <MenuItem value='any'>Any</MenuItem>
                  <MenuItem value='pending'>Pending</MenuItem>
                  <MenuItem value='approved'>Approved</MenuItem>
                  <MenuItem value='closed'>Closed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3}>
              <LocationSelect onUpdate={(value) => this.handleUpdate({location: value})} />
            </Grid>
            <Grid item xs={3} md={3}>
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onChange={(range) => this.setDateRange(range)}
              />
            </Grid>
          </Grid>
        </Paper>
        {type && <SpendingOverviewTable startDate={startDate} endDate={endDate} status={status} location={location} type={type} />}
      </Grid>

    );

  }
}
export default SpendingOverview;